import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  TextField,
  Typography,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

interface FieldProps {
  field: any;
}

interface CourseCreateStepOneProps {
  courseData: {
    category_id: string;
    name: string;
    planned_time: string;
    subscribe: boolean;
  };
  onDataChange: (
    data: Partial<{
      category_id: string;
      name: string;
      planned_time: string;
      subscribe: boolean;
    }>
  ) => void;
}

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .trim(" ")
    .min(3, "Минимальная длина названия курса - 3 символа")
    .max(50, "Максимальная длина названия курса - 50 символов")
    .matches(
      /.*[a-zA-Zа-яА-Я]+.*/,
      "Название курса должно содержать хотя бы одну букву"
    )
    .required("Название курса обязательно"),
  subscribe: Yup.boolean().oneOf([true], "Необходимо согласиться с условиями"),
});

const CourseCreateStepOne = ({
  courseData,
  onDataChange,
}: CourseCreateStepOneProps) => {
  return (
    <Formik
      initialValues={{
        name: courseData.name || "",
        subscribe: courseData.subscribe || false,
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        onDataChange(values);
      }}>
      {({
        errors,
        touched,
        handleChange,
        handleBlur,
        values,
        setFieldValue,
      }) => (
        <Form>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}>
            <div className="course-content">
              <div className="course-content-title">
                У вас уже есть рабочее название курса?
              </div>
              <div className="course-content-description">
                Если вы пока не придумали окончательное название своего курса,
                <br />
                ничего страшного. Название можно будет потом отредактировать.
              </div>

              <Field name="name">
                {({ field }: FieldProps) => (
                  <TextField
                    {...field}
                    variant="outlined"
                    placeholder="Пример, “Excel для начинающих”"
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    sx={{
                      marginTop: "32px",
                      width: 600,
                      "@media (max-width:1000px)": {
                        width: "100%",
                      },
                    }}
                    className="without-label"
                  />
                )}
              </Field>
              <div
                className={
                  values.name.length > 50
                    ? "description-input-counter error-text"
                    : "description-input-counter"
                }>
                {values.name.length}/50
              </div>

              <FormControl
                component="fieldset"
                error={touched.subscribe && Boolean(errors.subscribe)}>
                <FormGroup aria-label="position" row>
                  <FormControlLabel
                    control={
                      <Field name="subscribe">
                        {({ field }: FieldProps) => (
                          <Checkbox
                            {...field}
                            checked={field.value}
                            onChange={(e, checked) =>
                              setFieldValue("subscribe", checked)
                            }
                          />
                        )}
                      </Field>
                    }
                    label={
                      <Typography
                        component="div"
                        style={{
                          fontSize: "18px",
                          paddingTop: 25,
                          fontWeight: 400,
                          lineHeight: "135%",
                          color: "#808992",
                        }}>
                        Нажимая на кнопку, вы соглашаетесь c{" "}
                        <span
                          style={{
                            fontSize: "18px",
                            fontWeight: 400,
                            lineHeight: "135%",
                            color: "#0573E4",
                          }}>
                          Условиями для преподавателей
                        </span>
                      </Typography>
                    }
                    labelPlacement="end"
                  />
                </FormGroup>
                {touched.subscribe && errors.subscribe && (
                  <FormHelperText>{errors.subscribe}</FormHelperText>
                )}
              </FormControl>
            </div>

            <div className="course-create-footer">
              <Box
                sx={{
                  position: "fixed",
                  right: 0,
                  bottom: 0,
                  background: "#ffffff",
                  borderTop: "1px solid rgba(1, 18, 36, 0.08)",
                  padding: "12px 32px",
                  display: "flex",
                  justifyContent: "flex-end",
                  zIndex: 1000,
                  width: "calc(100% - 64px)",
                  boxSizing: "border-box",
                }}>
                <Button type="submit" variant="contained">
                  Продолжить
                </Button>
              </Box>
            </div>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default CourseCreateStepOne;
